import React, { FC } from 'react'

import { cn } from '../../../../../../lib/utils'

import { IRegistrationByDayInterface } from '../../../../../../models/registrations-by-day/registrationByDay.interface'

interface CustomScoringTotalProps {
  right?: boolean
  row: IRegistrationByDayInterface
}

export const CustomScoringTotal: FC<CustomScoringTotalProps> = ({ row, right }) => {
  const judge = row.score?.judges?.[0]
  return (
    <div className="flex flex-col">
      {row.isScratched ? (
        <p className="opacity-50">Scratched</p>
      ) : row.score?.scoreStatus ? (
        <p className="opacity-50">{row.score.scoreStatus}</p>
      ) : (
        judge?.customSections?.map((section) => {
          const showSection = section.type !== 'jump off' || judge.showJumpOff
          return (
            showSection && (
              <div
                key={section.id}
                className={cn(
                  'whitespace-nowrap inline-flex items-center gap-1',
                  right && 'text-right justify-end'
                )}
              >
                <p className="font-bold">{section.totalFaultsStatus || section.totalTime} •</p>{' '}
                <p>
                  {section.totalFaultsCount ?? 0}F
                  {judge?.scoreCardType !== 'optimum' && `/ ${section.totalTimeFaults ?? 0}TF`}
                </p>
              </div>
            )
          )
        })
      )}
    </div>
  )
}
